import { render, staticRenderFns } from "./pluginList.vue?vue&type=template&id=20831537&scoped=true"
import script from "./pluginList.vue?vue&type=script&lang=js"
export * from "./pluginList.vue?vue&type=script&lang=js"
import style0 from "./pluginList.vue?vue&type=style&index=0&id=20831537&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20831537",
  null
  
)

export default component.exports